var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.78033 11.0303C1.48744 11.3232 1.01256 11.3232 0.71967 11.0303C0.426777 10.7374 0.426777 10.2626 0.71967 9.96967L4.46967 6.21967C4.76256 5.92678 5.23744 5.92678 5.53033 6.21967L9.28033 9.96967C9.57322 10.2626 9.57322 10.7374 9.28033 11.0303C8.98744 11.3232 8.51256 11.3232 8.21967 11.0303L5 7.81066L1.78033 11.0303ZM1.78033 5.78033C1.48744 6.07322 1.01256 6.07322 0.71967 5.78033C0.426777 5.48744 0.426777 5.01256 0.71967 4.71967L4.46967 0.96967C4.76256 0.676777 5.23744 0.676777 5.53033 0.96967L9.28033 4.71967C9.57322 5.01256 9.57322 5.48744 9.28033 5.78033C8.98744 6.07322 8.51256 6.07322 8.21967 5.78033L5 2.56066L1.78033 5.78033Z",
    fill: "#30E0A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticUp);
export default __webpack_public_path__ + "static/media/statistic_up.8774f112896f3cd5120d2b238ef2abaa.svg";
export { ForwardRef as ReactComponent };